import ChatBorder from "views/ChatBorder.js";
import Profile from "views/examples/Profile.js";
import Password from "views/examples/Password.js";
import Answer from "views/examples/Answer.js";
import StartInfo from "views/examples/StartInfo.js";
import ChatBot from "views/examples/ChatBot.js";
import Icons from "views/examples/Keyword.js";
import Login from "views/examples/Login.js";
import Membership from "views/examples/Membership.js";
import Notification from "views/examples/Notification.js";
import NotificationEdit from "views/examples/NotificationEdit.js";

var routes = [
  {
    path: "/chatBorder",
    name: "채팅",
    icon: "ni ni-tv-2 text-gray",
    component: <ChatBorder />,
    layout: "/admin",
  },
  {
    path: "/keyword",
    name: "키워드 관리",
    icon: "ni ni-planet text-blue",
    component: <Icons />,
    layout: "/admin",
  },
  {
    path: "/answer",
    name: "답변 관리",
    icon: "fas fa-envelope text-orange",
    component: <Answer />,
    layout: "/admin",
  },
  {
    path: "/chatbot",
    name: "챗봇",
    icon: "ni ni-tablet-button text-black",
    component: '',
    layout: "/admin",
  },
  {
    path: "/chatbot-start",
    name: "시작하기",
    icon: "",
    component: <StartInfo />,
    layout: "/admin",
  },
  {
    path: "/chatbot-profile",
    name: "챗봇 관리",
    icon: "",
    component: <ChatBot />,
    layout: "/admin",
  },
  {
    path: "/user",
    name: "관리자",
    icon: "ni ni-single-02 text-yellow",
    component: '',
    layout: "/admin",
  },
  {
    path: "/user-profile",
    name: "관리자 프로필",
    icon: "",
    component: <Profile />,
    layout: "/admin",
  },
  {
    path: "/user-password",
    name: "비밀번호 변경",
    icon: "",
    component: <Password />,
    layout: "/auth",
  },
  {
    path: "/login",
    name: "로그인",
    icon: "ni ni-key-25 text-info",
    component: <Login />,
    layout: "/auth",
  },
  {
    path: "/membership",
    name: "회원가입",
    icon: "ni ni-key-25 text-info",
    component: <Membership />,
    layout: "/auth",
  },
  {
    path: "/notification",
    name: "공지사항",
    icon: "",
    component: <Notification />,
    layout: "/admin",
  },
  {
    path: "/noti_edit",
    name: "공지 작성",
    icon: "",
    component: <NotificationEdit />,
    layout: "/admin",
  }
];
export default routes;
